import { HeaderSectionItemButton, Icon, Popover } from '@antoree/ant-ui';
import { NotificationPopover } from 'components';
import { useNotificationContext } from 'contexts/NotificationContext';
import { useCallback, useEffect, useState } from 'react';

type Props = {};

const NotificationPopoverContainer = (props: Props) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isActiveNotification, setIsActiveNotification] = useState(false);
  const { notification: notificationData } = useNotificationContext();
  const onButtonClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
    setIsActiveNotification(false);
  };
  // eslint-disable-next-line no-shadow
  const closePopover = useCallback(() => setIsPopoverOpen(false), []);
  useEffect(() => {
    if (notificationData.createdAt) {
      setIsActiveNotification(true);
    }
  }, [notificationData]);
  return (
    <div>
      <Popover
        button={
          <HeaderSectionItemButton
            onClick={onButtonClick}
            notification={isActiveNotification}
          >
            <Icon type="bell" size="l" />
          </HeaderSectionItemButton>
        }
        isOpen={isPopoverOpen}
        closePopover={closePopover}
        repositionOnScroll
      >
        <NotificationPopover
          closePopover={closePopover}
          isPopoverOpen={isPopoverOpen}
        />
      </Popover>
    </div>
  );
};

export default NotificationPopoverContainer;
